<template>
	<div class="container">
		<div class="row p-t-2">
			<h2 class="col-xs-12 h4 more-heading">More {{ eventName }}</h2>
		</div>
		<div class="row p-b-grid">
			<div v-for="(occurrence, index) in nextOccurrences" :key="index" class="col-xs-12 col-md-4">
				<div class="bg-white p-a-1 m-b-sm">
					<a :href="occurrence.url" class="font-weight-bold"><TemporalDisplay :start="occurrence.startMoment" template="date"/></a>
					<div class="strong-start-time"><TemporalDisplay :start="occurrence.startMoment" :end="occurrence.endMoment" template="time"/></div>
					<div>{{ occurrence.instructorName }}</div>
					<div>{{ occurrence.location }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment';
import TemporalDisplay from '@/components/schreg-common/TemporalDisplay.vue';
import { FrameworkService } from '@/services/framework.service';

export default defineComponent({
	name: 'MoreSub',
	components: {
		TemporalDisplay
	},
	props: {
		eventName: {
			default: '',
			type: String
		},
		eventType: {
			default: '',
			type: String
		},
		nextOccurrences: {
			default: null,
			type: Array
		}
	},
	created() {
		for (let i = 0; i < this.nextOccurrences.length; i++) {
			this.nextOccurrences[i].startMoment = moment.parseZone(this.nextOccurrences[i].start);
			this.nextOccurrences[i].endMoment = moment.parseZone(this.nextOccurrences[i].end);
			this.nextOccurrences[i].url = this.eventType.includes('class') ? FrameworkService.classUrl(this.nextOccurrences[i].eventId) : FrameworkService.eventUrl(this.nextOccurrences[i].eventId);
		}
	}
});
</script>

<style scoped lang="scss">
.more-heading {
	text-transform: none;
}
.strong-start-time ::v-deep .time-start {
    font-weight: 700;
}
</style>
